var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"strip-topic",class:{
    'strip-left': _vm.position === 'left',
    'strip-right': _vm.position === 'right',
  }},[_c('div',{staticClass:"strip-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.brief)?_c('pre',{staticClass:"strip-brief"},[_vm._v(_vm._s(_vm.brief))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }